import { createSelector } from 'reselect';

import {
  isAuthenticatedWithBookings,
  isMissingBillingDetails,
  isMissingPayoutMethod,
} from 'ha/modules/AuthLogic/selectors';

const showWeWantToPay = createSelector(
  [isAuthenticatedWithBookings, isMissingPayoutMethod, isMissingBillingDetails],
  (authenticatedWithBookings, missingPayoutMethod, missingBillingDetails) =>
    authenticatedWithBookings && (missingBillingDetails || missingPayoutMethod),
);

export { showWeWantToPay };
